import React, { useState } from "react";
import { AiOutlineMinus } from "react-icons/ai";

// function isHTML(str) {
//   var doc = new DOMParser().parseFromString(str, "text/html");
//   return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
// }

const InputTagObject = ({
  label,
  length,
  name,
  defaultValue,
  type,
  multiple,
  required,
  disabled,
}) => {
  const [visibility, setVisibility] = useState(true);

  const handleDelete = () => {
    setVisibility(false);
  };
  return (
    <div
      key={Math.random()}
      className={visibility ? "flex gap-1 items-end w-full" : "hidden"}
    >
      <div className="w-full">
        <label className="label capitalize">
          <span className="text-md font-semibold">
            {multiple && length ? label + " " + length : label}
          </span>
        </label>
        <input
          name={visibility ? name : ""}
          defaultValue={defaultValue.url}
          type={type}
          className="w-full my-2 border border-gray-300 rounded-md px-3 py-2 z-0"
          required={required}
          disabled={disabled}
          alt={defaultValue._id}
        />
      </div>
      <div className={!multiple ? "hidden" : ""}>
        <button
          type="button"
          onClick={handleDelete}
          className="btn btn-sm btn-circle hover:bg-gray-50 border border-gray-400 mb-2 p-2 rounded-full"
        >
          <AiOutlineMinus />
        </button>
      </div>
    </div>
  );
};

export default InputTagObject;
